<template>
    <el-config-provider :locale="lang">
        <router-view></router-view>
        <!-- <PayAdModal /> -->
    </el-config-provider>
</template>
<script setup lang="ts">
import { onMounted, watch, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import iconfontInit from '/@/utils/iconfont'
import { useRoute } from 'vue-router'
import { setTitleFromRoute } from '/@/utils/common'
import { useConfig } from '/@/stores/config'
import { useTerminal } from '/@/stores/terminal'
// 导入 element-plus 语言包
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import en from 'element-plus/dist/locale/en.mjs'
// modules import mark, Please do not remove.
// import PayAdModal from '/@/components/apply/PayAdModal.vue'

const config = useConfig()
const route = useRoute()
const terminal = useTerminal()
// 初始化 element 的语言包
const lang = computed(() => {
  return config.lang.defaultLang === 'zh-cn' ? zhCn : en
})
// 全局事件总线：监听全局打开VIP弹框事件
// 由 PayAdModal 或其他全局组件触发
onMounted(() => {
    iconfontInit()
    terminal.init()

    // Modules onMounted mark, Please do not remove.
})

// 监听路由变化时更新浏览器标题
watch(
    () => route.path,
    () => {
        setTitleFromRoute()
    }
)
</script>